import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import all from './all';
import waiting from './waiting';
import replied from './replied';
import ticket from './ticket';

const Tickets = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/waiting-for-answer`}/>
      <Route path={`${match.url}/all`} component={all}/>
      <Route path={`${match.url}/waiting-for-answer`} component={waiting}/>
      <Route path={`${match.url}/replied-or-closed`} component={replied}/>
      <Route path={`${match.url}/:threadId`} component={ticket}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Tickets;
